<template>
  <header
    class="flex items-center h-full mainheader bg-base-0"
    :class="{'searching': searchValue}"
  >
    <span
      @click="showMenuMobile"
      class="px-4 py-4 cursor-pointer lg:hidden"
      v-if="!isDisabled"
    >
      <aha-icon
        name="hamburger-menu"
        class="text-secondary-100"
      />
    </span>

    <!-- Hack: Use div instead of ahref to avoid focus-within state which triggers search UX -->
    <div
      class="logo-merge-search-wrapper"
      @click="onClickLogo"
      v-if="!isPresenterWhiteLabel"
    >
      <aha-logo
        width="156"
        height="26"
        viewBox="0 0 9600 1602"
        class="block m-auto lg:ml-3.5"
      />
    </div>
    <div
      class="merge-template-search-wrapper"
      :class="{'show': isTemplateSearchVisible}"
      v-if="currentUser.id && !isHideSearchTemplateEu"
    >
      <TemplateSearch></TemplateSearch>
    </div>
    <span class="flex-grow hidden lg:inline-block" />

    <a
      class="flex mr-4 cursor-pointer gradient-gift text-secondary-100"
      @click="openReferral"
      v-if="currentUser.referralUserId && !currentUser.referralAwardStatus"
    >
      <img src="@/assets/images/icon/box.svg" class="relative -top-0.5 mr-1">
      <span class="text-gift">You’ve got a gift</span>
    </a>

    <span
      @click="onClickBtnUpgrade(true)"
      v-if="$store.state.plan.group == 'free' && $route.name !== 'Upgrade'"
      class="hidden mb-1 mr-4 lg:inline-block"
      v-show="!hasOnboardingV3"
    >
      <aha-button variant="success" class="py-1.5">
        Upgrade
      </aha-button>
    </span>

    <span
      @click="onClickBtnUpgrade"
    >
      <aha-plan-badge
        v-if="$store.state.plan.group != 'free'"
        :plan="$store.state.plan.name"
        class="hidden mr-4 plan-badge lg:inline-block badge-main-header"
        :class="{'lg:hidden': isPageUserCancelSub}"
      />
    </span>

    <aha-dropdown
      v-if="$store.state.plan.name"
      class="hidden lg:inline-block"
      :class="{'lg:hidden': isPageUserCancelSub}"
    >
      <aha-dropdown-trigger>
        <div
          @click="isProfileShowing = true"
          class="flex items-center cursor-pointer dropdown-wrapper"
        >
          <p
            class="inline-block mr-4 font-bold truncate dropdown-username
              text-link max-w-64 xl:max-w-108"
          >
            {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
          </p>
          <aha-avatar
            :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
            :image="$store.state.currentUser.avatar"
            :id="$store.state.currentUser.id"
            :width="40"
            :height="40"
            class="mr-2 text-lg"
          />
          <aha-icon class="mr-6" name="polygon" />
        </div>
      </aha-dropdown-trigger>
      <transition name="fade" appear>
        <div
          v-if="isProfileShowing"
          v-click-outside="handleClickOutsideProfile"
          class="absolute z-10 p-4 mt-6 rounded-md right-4 bg-base-0 shadow-dialog w-72"
        >
          <div
            class="flex p-2 rounded-md"
            :class="$store.state.plan.color2"
          >
            <aha-avatar
              :name="`${$store.state.currentUser.firstName} ${$store.state.currentUser.lastName}`"
              :image="$store.state.currentUser.avatar"
              :id="$store.state.currentUser.id"
              :width="48"
              :height="48"
              class="text-xl"
            />
            <div class="flex flex-col justify-between py-1 pl-3">
              <p class="font-bold truncate max-w-40">
                {{ $store.state.currentUser.firstName }} {{ $store.state.currentUser.lastName }}
              </p>
              <p class="text-xs truncate max-w-40">
                {{ $store.state.currentUser.email }}
              </p>
            </div>
          </div>
          <ul class="aha-menu">
            <li
              v-if="currentUser.identifyProvider != 'skoletube'"
              @click="routeAndClose('/apps/user-profile')"
            >
              <aha-icon name="profile" maintain-color />
              <span>My Profile</span>
            </li>
            <li
              v-if="currentUser.identifyProvider != 'skoletube' && !hasOnboardingV3"
              @click="routeAndClose('/apps/referral')"
            >
              <aha-icon name="coin" class="top opacity-60" />
              <span>Refer a Friend</span>
            </li>
            <li
              v-if="currentUser.identifyProvider != 'skoletube'
                && (workingMode !== 'team')"
              @click="routeAndClose('/apps/user-plan')"
            >
              <aha-icon name="bill" maintain-color />
              <span>My Plan</span>
              <aha-plan-badge
                :plan="$store.state.plan.name"
                use-short-name
                size="sm"
                class="float-right mt-2"
              />
            </li>
            <li
              v-if="currentUser.identifyProvider != 'skoletube'"
              @click="routeAndClose('/apps/billing')"
            >
              <aha-icon name="payment" maintain-color />
              <span>Payment</span>
            </li>
            <li @click="handleLogoutButtonClick">
              <aha-icon name="logout" maintain-color />
              <span>Log out</span>
            </li>
          </ul>
        </div>
      </transition>
    </aha-dropdown>
    <RefferalGift v-if="isOpenReferral" @hide="closeReferral()" />
  </header>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import debounce from 'debounce'
import config from '@/config'
import constants from '@/constant'
import utils from '@/util'

import RefferalGift from '@/components-v2/modals/ReferralGift.vue'
import TemplateSearch from '@/components-v2/template/TemplateSearch.vue'

const iconOpenLink = require('@/assets/images/vector.svg')

const { gaCategories } = constants

export default {
  components: {
    RefferalGift,
    TemplateSearch,
  },
  props: {
    isTemplateSearchVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isProfileShowing: false,
      searchValue: '',
      tooltipHelp: {
        content: `<img src="${iconOpenLink}" class="inline-block relative -top-0.5"></i> This link opens in a new tab`,
      },
      isOpenReferral: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      plan: (state) => state.plan,
      isPresenterWhiteLabel: (state) => state.isPresenterWhiteLabel,
      hasOnboardingV3: (state) => state.indicators.hasOnboardingV3,
      isOnboardingV3Showing: (state) => state.indicators.isOnboardingV3Showing,
      workingMode: (state) => state.workingMode,
    }),
    isCasualUserNotHaveTeam() {
      return this.currentUser && !this.currentUser.accountId
    },
    isDisabled() {
      return this.$route.name === 'Upgrade' || this.$route.name === 'UserCancelSub'
    },
    isPageUserCancelSub() {
      return this.$route.name === 'UserCancelSub'
    },
    isEURegion() {
      return config.region === constants.euRegion
    },
    isHideSearchTemplateEu() {
      if (this.isEURegion && this.$route.name === 'TemplateLibrary') {
        return true
      }
      return false
    },
  },
  watch: {
    $route(to) {
      if (to.name === 'Presentations') {
        this.searchValue = this.$route.query.q || ''
      } else {
        this.searchValue = ''
      }
    },
  },
  mounted() {
    if (this.$route.query.q) {
      this.searchValue = this.$route.query.q
    }
  },
  methods: {
    ...mapActions(['setIsOnboardingV3ShowingAction']),
    onClickBtnUpgrade(isUpdate = false) {
      if (config.region !== constants.euRegion) {
        let eventLabel = 'Free'
        if (isUpdate) {
          eventLabel = this.$store.state.plan.name
        }
        utils.gaTrackEvent(this.$route.meta.title, 'Presenter App > Header > Upgrade', eventLabel)
        this.$router.push({ name: 'UserPlan' })
      }
    },
    openReferral() {
      this.isOpenReferral = true
      utils.gaTrackEvent(
        'Presenter Referral Program',
        'Presenter Referral Program > Click open gift ',
        'Click open gift',
      )
    },
    closeReferral() {
      this.isOpenReferral = false
    },
    handleLogoutButtonClick() {
      utils.logout(this.currentUser)
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Logout')
    },

    _onSearchInput: debounce(function onSearchInputDebounce() {
      const query = {}
      if (this.searchValue.length !== 1) {
        if (this.searchValue.length > 1) {
          query.q = this.searchValue
        }
        this.$router.push({ name: 'Presentations', query })
      }
    }, 600),

    routeAndClose(path) {
      this.setIsOnboardingV3ShowingAction(false)
      this.$router.push(path)
      this.isProfileShowing = false
      if (window.innerWidth > 1023 && localStorage.getItem(`skipped-welcome-popup-${this.currentUser.id}`) === 'true') {
        this.$emit('showHomeSideBar')
      }
    },

    handleClickOutsideProfile() {
      this.isProfileShowing = false
    },

    showMenuMobile() {
      this.$store.state.indicators.isHomeSideBarShowing = true
    },
    hideMenuMobile() {
      if (window.innerWidth > 1023) return
      this.$store.state.indicators.isHomeSideBarShowing = false
    },
    focusSearch() {
      this.$refs.search.focus()
    },
    onClickLogo() {
      if (this.$route.name === 'Upgrade') {
        // Dont use vue-router on Upgrade page, to clean up state and reload full page.
        this.$func.go(`${config.presenterDomain}/apps/presentations`)
      } else {
        if (this.$store.state.workingMode === 'personal') this.$router.push({ name: 'Presentations' })
        else this.$router.push({ name: 'Team' })
        if (this.hasOnboardingV3) {
          this.setIsOnboardingV3ShowingAction(true)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search-presentation-wrapper {
  @apply lg:ml-6 flex items-center;
  transition: .15s ease;
}

.search-presentation-wrapper.disabled {
  @apply hidden;
}

.logowrapper {
  @apply opacity-100 flex-grow lg:flex-grow-0 lg:w-auto cursor-pointer;
  transition: .15s ease;
}

.search-presentation-wrapper:hover {
  .search__icon {
    @apply text-primary-90;
  }
}

.mainheader.searching,
.mainheader:focus-within {
  .logowrapper {
    @apply opacity-0 overflow-hidden max-w-0 lg:max-w-full lg:opacity-100 lg:w-auto;
  }
}

.search-presentation-wrapper.has-value,
.search-presentation-wrapper:focus-within {
  @apply w-full max-w-full lg:w-auto;

  .search__icon {
    @apply text-primary-90;
  }

  form {
    @apply w-4/5 lg:w-auto;
  }

  .search__input,
  .search__input:focus {
    @apply opacity-100 mr-4 w-full max-w-full lg:w-56;
  }
}

.search__input {
  @apply outline-none inline-block flex-grow w-0 max-w-56 lg:w-56 mr-2;
  @apply cursor-pointer;
  -webkit-appearance: none;
}

.search__icon {
  @apply text-base-80 lg:text-base-50;
  transition: .15s ease;
}

.aha-menu {
  @apply mt-2;

  li {
    @apply leading-10 px-3 hover:bg-base-20 cursor-pointer;
    @apply text-base-90 whitespace-nowrap;
    svg {
      @apply mr-2;
    }
  }
}
.aha-menu-title {
  @apply uppercase tracking-widest text-xs px-3 my-2;
}

.dropdown-wrapper {
  &:hover .dropdown-username {
    @apply text-primary-90;
  }
}
p.dropdown-username {
  @apply capitalize;
  line-height: 1.1rem;
  .credit {
    @apply font-light text-base-80 text-xs;
    margin-top: 2px;
    display: block;

    img {
      position: relative;
      top: -2px;
    }
  }
}

.icon-color {
  opacity: 0.6;
}

.merge-template-search-wrapper {
  @apply w-1/2 hidden;
  &.show {
    @apply block;
  }
}
@media (max-width: 1024px) {
  .text-gift {
    display: none;
  }
  .merge-template-search-wrapper {
    width: 100%;
  }
}

.logo-merge-search-wrapper {
  @apply cursor-pointer;
}

.plan-badge{
  &:hover{
    cursor: pointer;
  }
}

.badge-main-header{
  &:hover{
    &.bg-yellow-50{
      box-shadow: 0 1px 10px rgb(255 174 9 / 40%);
    }
    &.bg-green-50{
      box-shadow: 0 1px 10px rgb(40 194 112 / 40%);
    }
    &.bg-purple-50{
      box-shadow: 0 1px 10px rgb(118 105 191 / 40%);
    }
    &.bg-primary-90{
      box-shadow: 0 1px 10px rgb(52 142 246 / 40%);
    }
  }
}

</style>
